import service from '@/services/superaccess'

const advance_search = {
  state: {},
  mutations: {},
  getters: {},
  actions: {
    advanceSearchPerson (context, payload) {
      return service.post('/api/advance_search/person', context, { identification: payload })
    },
    advanceSearchBycicle (context, payload) {
      return service.post('/api/advance_search/bycicle', context, { identification: payload })
    },
    advanceSearchVehicle (context, payload) {
      return service.post('/api/advance_search/vehicle', context, { identification: payload })
    },
    advanceSearchCargo (context, payload) {
      return service.post('/api/advance_search/cargo', context, { identification: payload })
    },
    advanceSearchForced (context, payload) {
      return service.post('/api/advance_search/forced', context, { identification: payload })
    }
  }
}
export default advance_search



// WEBPACK FOOTER //
// app/javascript/src/store/advance_search.js